import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, CardHeader, CardContent, Stack, TableContainer, Modal, Button } from '@mui/material';
import ParentAndParticipantForm from './ParentAndParticipantForm';
import AddPositionModal from './AddPositionModal';
import { Positions } from '../../Positions';
import AddIcon from '@mui/icons-material/Add';
import OLOrderDetailsForm from './OLOrderDetailsForm';
import ZSOrderDetailsForm from './ZSOrderDetailsForm';
import PLOrderDetailsForm from './PLOrderDetailsForm';
import WROrderDetailsForm from './WROrderDetailsForm';
import ZSRepresentativesForm from './ZSRepresentativesForm';
import WRRepresentativesForm from './WRRepresentativesForm';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


const OrderTab = ({ formik }) => {
  const { module } = useSelector(state => state.app);
  const { order } = useSelector(state => state.orderData);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} ml={2} mr={2}>
          <Stack flex="1 1 50%" mr={2}>
            <Card>
              <CardHeader
                title="Dane zamówienia"
                sx={{ mt: -1, mb: -2 }}
              />
              <CardContent>
                {
                  module == 'obozy' ? <OLOrderDetailsForm formik={formik} />
                    : module == 'polkolonie' ? <PLOrderDetailsForm formik={formik} />
                      : module == 'zielone_szkoly' ? <ZSOrderDetailsForm formik={formik} />
                        : module == 'wyjazdy_rodzinne' ? <WROrderDetailsForm formik={formik} /> : null

                }
              </CardContent>
            </Card>
          </Stack>
          <TableContainer component={Card} sx={{ flex: '1 1 50%' }}>
            <CardHeader
              title={<>
                Pozycje zamówienia
                <Button
                  onClick={handleOpen}
                  variant="contained"
                  startIcon={<AddIcon />}
                  sx={{ ml: 2 }}
                >
                Dodaj Pozycje
                </Button>
              </>
              }
              sx={{ mb: 2, mt: -1 }}
            />
            <Positions positions={order.products} order={order} formik={formik} module={module} />
          </TableContainer>
        </Box>
        {
          module == 'obozy' ? <ParentAndParticipantForm formik={formik} />
            : module == 'polkolonie' ? <ParentAndParticipantForm formik={formik} />
              : module == 'zielone_szkoly' ? <ZSRepresentativesForm formik={formik} />
                : module == 'wyjazdy_rodzinne' ? <WRRepresentativesForm formik={formik} /> : null
        }
      </form>
      <Modal
        open={open}
        onClose={handleClose}
      >
        <Card sx={{ ...style, width: '80vw' }}>
          <CardHeader title="Dodaj pozycje" />
          <CardContent>
            <AddPositionModal order={order} handleClose={handleClose} formik={formik} module={module} />
          </CardContent>
        </Card>
      </Modal>
    </Box>
  );
};

export default OrderTab;

